import { inject, Injectable } from '@angular/core';
import { HttpService } from '@utils/http.service';

@Injectable({
  providedIn: 'root',
})
export class RenapoService {
  private http = inject(HttpService);

  public curpList = async () => await this.http.get(`/v1/renapo/curp`, false).then((response: any) => response.data.content.sort());
  public curpUpload = async (body: any) => await this.http.post(`/v1/renapo/curp`, body).then((response: any) => response.data);

  public correccionCurpList = async () => await this.http.get(`/v1/renapo/correccion-curp`, false).then((response: any) => response.data.content.sort());
  public correccionCurpUpload = async (body: any) => await this.http.post(`/v1/renapo/correccion-curp`, body).then((response: any) => response.data);

  public unificacionCurpList = async () => await this.http.get(`/v1/renapo/unificacion-curp`, false).then((response: any) => response.data.content.sort());
  public unificacionCurpUpload = async (body: any) => await this.http.post(`/v1/renapo/unificacion-curp`, body).then((response: any) => response.data);

  public certificacionCurpList = async () => await this.http.get(`/v1/renapo/certificacion-curp`, false).then((response: any) => response.data.content.sort());
  public certificacionCurpUpload = async (body: any) => await this.http.post(`/v1/renapo/certificacion-curp`, body).then((response: any) => response.data);
}
